// jshint esversion: 8
const uuidTemplate = 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx';
export default () => {
  var ts = new Date().getTime();
  return uuidTemplate.replace(/[xy]/g, c => {
    var r = (ts + Math.random() * 16) % 16 | 0;
    ts = Math.ceil(ts/16);
    return (c === 'x' ? r : ( r & 0x3 | 0x8 )).toString(16);
  });
};
